import useRootQuery from "../../../internal/revamp/graphql/useRootQuery";
/**
 *
 * @see https://sail.stripe.me/data/api/unstable_CompositionFragmentRunner
 */ export default function CompositionFragmentRunner({ useCompositionFragmentConfig, token }) {
    const [compositionFragment, options] = useCompositionFragmentConfig({
        token
    });
    useRootQuery(compositionFragment, options);
    return null;
}

//# sourceMappingURL=CompositionFragmentRunner.js.map